export default {
  getChampionship(state) {
    return state.championship;
  },
};
